import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'


const dataInicial = {
    asociadolocalidad: []
}

//DEFINICIÓN DE MÉTODOS *********************************************************************************************

const GET_ALL_ASOCIADOS_BY_SUBLOCALIDAD = 'GET_ALL_ASOCIADOS_BY_SUBLOCALIDAD'
const GET_ASOCIADOS_BY_SUBLOCALIDAD = 'GET_ASOCIADOS_BY_SUBLOCALIDAD'
const INSERT_ASOCIADO_SUBLOCALIDAD = 'INSERT_ASOCIADO_SUBLOCALIDAD'
const DELETE_ASOCIADO_SUBLOCALIDAD = 'DELETE_ASOCIADO_SUBLOCALIDAD'

//*******************************************************************************************************************


//METODOS
export const obtenerAsociadosLocalidad = createAsyncThunk(
    GET_ALL_ASOCIADOS_BY_SUBLOCALIDAD,
    async () => {
        try {
            const fullUrl = host + `AsociadosEnLaLocalidad/obtenerAsociadosLocalidad`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)
export const obtenerAsociadosLocalidadByIdSublocalidad = createAsyncThunk(
    GET_ASOCIADOS_BY_SUBLOCALIDAD,
    async (idsublocalidad) => {
        try {
            const fullUrl = host + `AsociadosEnLaLocalidad/obtenerAsociadosLocalidadByIdSublocalidad/${idsublocalidad}`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)
export const agregarAsociadoLocalidad = createAsyncThunk(
    INSERT_ASOCIADO_SUBLOCALIDAD,
    async (data) => {
        try {
            const fullUrl = host + `AsociadosEnLaLocalidad/agregarAsociadoLocalidad`
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const eliminarAsociadoLocalidad = createAsyncThunk(
    DELETE_ASOCIADO_SUBLOCALIDAD,
    async (idasociadolocalidad) => {
        try {
            const fullUrl = host + `AsociadosEnLaLocalidad/eliminarAsociadoLocalidad/${idasociadolocalidad}`
            //alert(JSON.stringify(data))
            const result = await axios.delete(fullUrl)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)


//****************************************************************************************************************
//EXPORTS DE MÉTODOS

export const metodosAsociadoLocalidadSlice = createSlice({

    name: 'metodosAsociadoLocalidadSlice',
    initialState: dataInicial,
    reducers: {
    },
    extraReducers: {
        [obtenerAsociadosLocalidadByIdSublocalidad.fulfilled]: (state, { payload }) => {
            state.asociadolocalidad = payload.data.data
        },
        [obtenerAsociadosLocalidad.fulfilled]: (state, { payload }) => {
        },
        [agregarAsociadoLocalidad.fulfilled]: (state, { payload }) => {
        },
        [eliminarAsociadoLocalidad.fulfilled]: (state, { payload }) => {
        }
    },

})

export const { } = metodosAsociadoLocalidadSlice.actions
export const AsociadoLocalidadReducer = metodosAsociadoLocalidadSlice.reducer